import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import React, { FC, useEffect, useState } from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';

//
export default function CustomDropdown(props: any) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
        if (!props.loading)
            setAnchorEl(event.currentTarget);
    };

    const handleClose = (event: any, option: string) => {
        setAnchorEl(null);
        event.stopPropagation();

        // Call select handler!
        if (option !== "backdropClick") {
            props.onSelect(option);
        }
    };

    //
    return (
        <Box sx={{ width: "70px" }}>
            <Box sx={{
                display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer",
                color: "white", background: "#443224",
                borderRadius: "5px", height: "33px",
                padding: "3px",
                transition: "background .2s linear",
                "&:hover": {background: "#4b3829"}
                //boxShadow: "0px 0px 11px #573c2a"
            }}
                onClick={handleClick}>

                {!props.loading && props.icon}
                {!props.loading && !open && <ArrowDropUpIcon sx={{ fontSize: "28px" }} />}
                {!props.loading && open && <ArrowDropDownIcon sx={{ fontSize: "28px" }} />}
                {props.loading && <CircularProgress sx={{ width: "20px!important", height: "20px!important" }} color="inherit" />}

                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                    sx={{
                        ".MuiPaper-root": {
                            background: "#443224",
                            color: "white",
                            border: "1px solid #544030"
                        },
                        "li": {
                            background: "#443224",
                            "&:hover": {
                                background: "#624b39"
                            }
                        }
                    }}>

                    {
                        props.options.map((o: any) => {
                            return (
                                <MenuItem key={o.id} onClick={(e: any) => handleClose(e, o.id)}>{o.label}</MenuItem>
                            )
                        })
                    }
                </Menu>
            </Box>
        </Box>
    )
}
